/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import { customInstance } from '../../../customInstance'
import type { ErrorType } from '../../../customInstance'
import type {
    DeleteRequestDevicesByDeviceIdParams,
    GetRequestLogoutParams,
    HTTPValidationErrorDTO,
    LogoutResponseDTO,
    OptionalMessageResponseDTO,
    PostRequestDevicesDeleteByDeviceIdParams,
    PostRequestLogoutParams,
} from '../../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Logout and delete the Capture token used in the API call.
If the user has an active TelenorID session we also try to do a logout
from TelenorID

 * @summary Logout
 */
export const postRequestLogout = (
    params?: PostRequestLogoutParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<LogoutResponseDTO>(
        { url: `/logout`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestLogoutMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestLogout>>,
        TError,
        { params?: PostRequestLogoutParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestLogout>>,
    TError,
    { params?: PostRequestLogoutParams },
    TContext
> => {
    const mutationKey = ['postRequestLogout']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestLogout>>,
        { params?: PostRequestLogoutParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestLogout(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestLogoutMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestLogout>>
>

export type PostRequestLogoutMutationError = ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Logout
 */
export const usePostRequestLogout = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestLogout>>,
            TError,
            { params?: PostRequestLogoutParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestLogout>>,
    TError,
    { params?: PostRequestLogoutParams },
    TContext
> => {
    const mutationOptions = getPostRequestLogoutMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Logout and delete the Capture token used in the API call.
If the user has an active TelenorID session we also try to do a logout
from TelenorID

 * @summary Logout
 */
export const getRequestLogout = (
    params?: GetRequestLogoutParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<LogoutResponseDTO>(
        { url: `/logout`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestLogoutQueryKey = (params?: GetRequestLogoutParams) => {
    return [`/logout`, ...(params ? [params] : [])] as const
}

export const getGetRequestLogoutQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestLogout>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params?: GetRequestLogoutParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestLogout>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestLogoutQueryKey(params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestLogout>>> = ({ signal }) =>
        getRequestLogout(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestLogout>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestLogoutQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestLogout>>>
export type GetRequestLogoutQueryError = ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestLogout<
    TData = Awaited<ReturnType<typeof getRequestLogout>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: undefined | GetRequestLogoutParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestLogout>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestLogout>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestLogout>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestLogout<
    TData = Awaited<ReturnType<typeof getRequestLogout>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params?: GetRequestLogoutParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestLogout>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestLogout>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestLogout>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestLogout<
    TData = Awaited<ReturnType<typeof getRequestLogout>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params?: GetRequestLogoutParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestLogout>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Logout
 */

export function useGetRequestLogout<
    TData = Awaited<ReturnType<typeof getRequestLogout>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params?: GetRequestLogoutParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestLogout>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestLogoutQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This api call is used to invalidate the auth token for the device

 * @summary Delete Devices
 */
export const deleteRequestDevicesByDeviceId = (
    deviceId: string,
    params: DeleteRequestDevicesByDeviceIdParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<OptionalMessageResponseDTO>(
        { url: `/devices/${encodeURIComponent(String(deviceId))}`, method: 'DELETE', params },
        options,
    )
}

export const getDeleteRequestDevicesByDeviceIdMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestDevicesByDeviceId>>,
        TError,
        { deviceId: string; params: DeleteRequestDevicesByDeviceIdParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestDevicesByDeviceId>>,
    TError,
    { deviceId: string; params: DeleteRequestDevicesByDeviceIdParams },
    TContext
> => {
    const mutationKey = ['deleteRequestDevicesByDeviceId']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestDevicesByDeviceId>>,
        { deviceId: string; params: DeleteRequestDevicesByDeviceIdParams }
    > = (props) => {
        const { deviceId, params } = props ?? {}

        return deleteRequestDevicesByDeviceId(deviceId, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestDevicesByDeviceIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestDevicesByDeviceId>>
>

export type DeleteRequestDevicesByDeviceIdMutationError = ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Delete Devices
 */
export const useDeleteRequestDevicesByDeviceId = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestDevicesByDeviceId>>,
            TError,
            { deviceId: string; params: DeleteRequestDevicesByDeviceIdParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestDevicesByDeviceId>>,
    TError,
    { deviceId: string; params: DeleteRequestDevicesByDeviceIdParams },
    TContext
> => {
    const mutationOptions = getDeleteRequestDevicesByDeviceIdMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Use DELETE /devices/{device_id}
 * @deprecated
 * @summary Delete Devices
 */
export const postRequestDevicesDeleteByDeviceId = (
    deviceId: string,
    params: PostRequestDevicesDeleteByDeviceIdParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<OptionalMessageResponseDTO>(
        {
            url: `/devices/${encodeURIComponent(String(deviceId))}/delete`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestDevicesDeleteByDeviceIdMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestDevicesDeleteByDeviceId>>,
        TError,
        { deviceId: string; params: PostRequestDevicesDeleteByDeviceIdParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestDevicesDeleteByDeviceId>>,
    TError,
    { deviceId: string; params: PostRequestDevicesDeleteByDeviceIdParams },
    TContext
> => {
    const mutationKey = ['postRequestDevicesDeleteByDeviceId']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestDevicesDeleteByDeviceId>>,
        { deviceId: string; params: PostRequestDevicesDeleteByDeviceIdParams }
    > = (props) => {
        const { deviceId, params } = props ?? {}

        return postRequestDevicesDeleteByDeviceId(deviceId, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestDevicesDeleteByDeviceIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestDevicesDeleteByDeviceId>>
>

export type PostRequestDevicesDeleteByDeviceIdMutationError = ErrorType<HTTPValidationErrorDTO>

/**
 * @deprecated
 * @summary Delete Devices
 */
export const usePostRequestDevicesDeleteByDeviceId = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestDevicesDeleteByDeviceId>>,
            TError,
            { deviceId: string; params: PostRequestDevicesDeleteByDeviceIdParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestDevicesDeleteByDeviceId>>,
    TError,
    { deviceId: string; params: PostRequestDevicesDeleteByDeviceIdParams },
    TContext
> => {
    const mutationOptions = getPostRequestDevicesDeleteByDeviceIdMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
